/**
 * ChannelViewContainer component.
 */
import StyledChannelViewContainer from '@components/atoms/container/styledChannelViewContainer';
import SelectViewContainer from '@components/atoms/container/selectViewContainer';
import ChannelViewTitle from '@components/atoms/text/channelViewTitle';
import ChannelViewWindow from '@components/atoms/images/channelViewWindow';
import SelectViewButton from '@components/atoms/buttons/selectViewButton';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useList from '@shared/components/utils/hooks/useList';
import type Props from '@shared/types/props/pressable';
import { magicRemoteSelector } from '@shared/store/slices/magicRemote.slice';
import { useAppSelector } from '@shared/store/hooks';
import SelectViewButtonContainer from '@components/atoms/container/selectViewButtonContainer';

/**
 * Props for the ChannelViewContainer component.
 * */
type ChannelViewProps = {
  action: () => void;
  text: string;
  Icon: React.FC<Props>;
  image: string;
  index: number;
};

/**
 * Renders a container with a channel view window and a select view button.
 */
export default function ChannelViewContainer({
  text,
  Icon,
  image,
  index,
  action,
}: ChannelViewProps) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { focused, listIndex } = useList(index);
  const buttonFocused = !enabled && focused && listIndex === index;
  return (
    <StyledChannelViewContainer>
      <SelectViewContainer>
        <Icon width={63} height={67} margin={'44px 0 0 0'}></Icon>
        <ChannelViewTitle>{text}</ChannelViewTitle>
        <ChannelViewWindow src={image} />
      </SelectViewContainer>
      <SelectViewButtonContainer focused={buttonFocused}>
        <SelectViewButton focused={buttonFocused} onClick={action}>
          {TranslationManager.get('PAGES.CHANNELS_CHOICE.BUTTON')}
        </SelectViewButton>
      </SelectViewButtonContainer>
    </StyledChannelViewContainer>
  );
}
